export default "__VITE_ASSET__Wols_oyO__"